export const ArrowDown = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <defs>
      <filter id='dropShadow' x='-50%' y='-50%' width='200%' height='200%'>
        <feDropShadow
          dx='0'
          dy='2'
          stdDeviation='1'
          floodColor='rgba(0,0,0,0.25)'
        />
      </filter>
    </defs>
    <g id='12px / arrow_dropdown 2'>
      <path
        id='Subtract'
        d='M6 9L0 3H12L6 9Z'
        fill='#00323D'
        filter='url(#dropShadow)'
      />
    </g>
  </svg>
)
